import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Meeting} from "../../../shared/interface/meeting";
import {
  MEETING_TYPE_ADA,
  MEETING_TYPE_IDD_TRAINING, MEETING_TYPE_MEETING,
  MEETING_TYPE_NEW_AGENT_TRAINING, MEETING_TYPE_OTHER, MEETING_TYPE_TRAINING
} from "../../../shared/services/dict.service";
import {MeetingDetailsViewDialogComponent} from "../meeting-details-view-dialog/meeting-details-view-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";

@Component({
  selector: 'app-calendar-event',
  templateUrl: './calendar-event.component.html',
  styleUrls: ['./calendar-event.component.scss']
})
export class CalendarEventComponent implements OnInit {
  @Input() meeting: Meeting;
  @Input() dialogRef = true;
  @Output() closeModification = new EventEmitter<any>();

  readonly MEETING_TYPE_IDD_TRAINING = MEETING_TYPE_IDD_TRAINING;
  readonly MEETING_TYPE_NEW_AGENT_TRAINING = MEETING_TYPE_NEW_AGENT_TRAINING;
  readonly MEETING_TYPE_ADA = MEETING_TYPE_ADA;
  readonly MEETING_TYPE_TRAINING = MEETING_TYPE_TRAINING;
  readonly MEETING_TYPE_MEETING = MEETING_TYPE_MEETING;
  readonly MEETING_TYPE_OTHER = MEETING_TYPE_OTHER;

  tooltipText = '';

  constructor(
    private dialog: MatDialog,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (this.meeting.subject) {
      this.tooltipText = 'Temat: ' + this.meeting.subject;
    }
  }

  handleEventClick(): void  {
    // if (!this.dialogRef) {
    //   this.router.navigate(['/szkolenie/szczegoly', this.meeting.uuid]);
    // } else {
      const dialogRef = this.dialog.open(MeetingDetailsViewDialogComponent, {
        width: '50%',
        maxHeight: '60vh',
        data: {
          meeting: this.meeting.uuid,
          dialogActive: true
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        this.closeModification.emit(true);
      });
    }
  // }

}
